import React, { Component } from "react";
// import CustomerDefectList from '../components/CustomerDefectList';
import { withStyles } from '@material-ui/core/styles';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';

var AWS = require('aws-sdk'),
    endpoint = "https://secretsmanager.us-west-2.amazonaws.com",
    region = "us-west-2",
    secretName = "test",
    secret,
    binarySecretData;

// Create a Secrets Manager client
var client = new AWS.SecretsManager({
    endpoint: endpoint,
    region: region
});

client.getSecretValue({SecretId: secretName}, function(err, data) {
    if(err) {
        if(err.code === 'ResourceNotFoundException')
            console.log("The requested secret " + secretName + " was not found");
        else if(err.code === 'InvalidRequestException')
            console.log("The request was invalid due to: " + err.message);
        else if(err.code === 'InvalidParameterException')
            console.log("The request had invalid params: " + err.message);
    }
    else {
        // Decrypted secret using the associated KMS CMK
        // Depending on whether the secret was a string or binary, one of these fields will be populated
        if(data.SecretString !== "") {
            secret = data.SecretString;
        } else {
            binarySecretData = data.SecretBinary;
        }
    }

    console.log('<> test <> test <> test <> test <>');
    console.log(data);
    console.log(secret);
    console.log(binarySecretData);
    
    // Your code goes here. 
    
});

const tileData = [
     {
       img: 'https://s3-us-west-2.amazonaws.com/dj-icons/statusClosed.svg',
       title: 'Image',
       author: 'author',
       cols: 1,
     },
     {
       img: 'https://s3-us-west-2.amazonaws.com/dj-icons/statusClosed.svg',
       title: 'Image',
       author: 'author',
       cols: 1,
     },
     {
       img: 'https://s3-us-west-2.amazonaws.com/dj-icons/statusClosed.svg',
       title: 'Image',
       author: 'author',
       cols: 1,
     },
     {
       img: 'https://s3-us-west-2.amazonaws.com/dj-icons/statusClosed.svg',
       title: 'Image',
       author: 'author',
       cols: 1,
     },
     {
       img: 'https://s3-us-west-2.amazonaws.com/dj-icons/statusClosed.svg',
       title: 'Image',
       author: 'author',
       cols: 1,
     },
   ];

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
  subheader: {
    width: '100%',
  },
});

class Test extends Component {


  constructor(props) {
    super(props)
    this.state = {}
  }


  handleClick() {
    this.props.handleFilter('test')
  }


  render() {
    const { classes } = this.props;
    return (
      <div>
      <br></br>
      <br></br>
      <hr></hr>
      <div className={classes.root}>
        <GridList cellHeight={160} className={classes.gridList} cols={3}>
          {tileData.map(tile => (
            <GridListTile key={tile.img} cols={tile.cols || 1} rows={tile.rows || 1}>
              <img src={tile.img} alt={tile.title} />
            </GridListTile>
          ))}
        </GridList>
      </div>
      </div>
    )
  }
}

export default withStyles(styles)(Test);


// WEBPACK FOOTER //
// ./src/js/pages/Test.js